'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeAccountForm = exports.accountFormAction = exports.ACCOUNT_FORM = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.buildAccountDetails = buildAccountDetails;
exports.buildProduct = buildProduct;
exports.createAccount = createAccount;
exports.doInitializeAccountForm = doInitializeAccountForm;
exports.doSubmitAccountForm = doSubmitAccountForm;
exports.watchAccountFormSagas = watchAccountFormSagas;

var _universalConfig = require('universal-config');

var _universalConfig2 = _interopRequireDefault(_universalConfig);

var _universalLogger = require('universal-logger');

var logger = _interopRequireWildcard(_universalLogger);

var _reduxForm = require('redux-form');

var _reduxFormSaga = require('redux-form-saga');

var _effects = require('redux-saga/effects');

var _helpers = require('redux/saga/helpers');

var _friendbuy = require('redux/saga/selectors/friendbuy');

var _locale = require('redux/modules/locale');

var _deep = require('helpers/deep');

var _multitrack = require('helpers/multitrack');

var _utmValues = require('helpers/utmValues');

var _Consent = require('components/Consent/Consent.saga');

var _ApiError = require('components/Errors/ApiError');

var _Authentication = require('features/Login/Authentication.saga');

var _Signup = require('features/Signup/Signup.saga');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(buildAccountDetails),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(createAccount),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(doInitializeAccountForm),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(doSubmitAccountForm),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(watchAccountFormSagas);

var ACCOUNT_FORM = exports.ACCOUNT_FORM = 'signup-card-account';
var accountFormAction = exports.accountFormAction = (0, _reduxFormSaga.createFormAction)(ACCOUNT_FORM);

var initializeAccountForm = exports.initializeAccountForm = function initializeAccountForm(hiddenFields) {
  return {
    type: 'INITIALIZE_' + ACCOUNT_FORM,
    hiddenFields: hiddenFields
  };
};

function buildAccountDetails(client, form) {
  var _ref, _ref2, activeLocation, consents, conversion, friendbuyCode, locale, user;

  return _regenerator2.default.wrap(function buildAccountDetails$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.all)([(0, _effects.call)(_helpers.getUserLocation, client), (0, _effects.call)(_Consent.transformConsentForApi, form), (0, _effects.call)(_utmValues.getForApi), (0, _effects.select)(_friendbuy.friendbuyCode), (0, _effects.select)(_locale.selectUserLocale)]);

        case 2:
          _ref = _context.sent;
          _ref2 = (0, _slicedToArray3.default)(_ref, 5);
          activeLocation = _ref2[0];
          consents = _ref2[1];
          conversion = _ref2[2];
          friendbuyCode = _ref2[3];
          locale = _ref2[4];


          // Ensure RAF leads are correctly tracked
          if (friendbuyCode) {
            (0, _deep.deepAssign)('utm.utm_term', conversion, friendbuyCode);
          }

          // NOTE: changed through nav language selection
          user = {
            email: form.email,
            first_name: form.firstName,
            last_name: form.lastName,
            locale: locale
          };
          return _context.abrupt('return', {
            client_id: (0, _universalConfig2.default)().clientId,
            consents: consents,
            conversion: conversion,
            newsletter_subscribed: form.marketing,
            gls_location_id: (0, _deep.deepExtract)('location.id', activeLocation, null),
            user: user
          });

        case 12:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function buildProduct(form) {
  var productKey = {
    offer: 'msa_offer_id',
    plan: 'plan_id'
  }[form.productType];

  return productKey ? (0, _defineProperty3.default)({}, productKey, form.productId) : {};
}

function createAccount(client, accountDetails, product) {
  return _regenerator2.default.wrap(function createAccount$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.call)(_Authentication.createUserAndLogIn, client, accountFormAction, (0, _extends3.default)({}, accountDetails, product));

        case 2:
          return _context2.abrupt('return', _context2.sent);

        case 3:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function doInitializeAccountForm(client, _ref4) {
  var hiddenFields = _ref4.hiddenFields;
  var consent;
  return _regenerator2.default.wrap(function doInitializeAccountForm$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.call)(_Consent.loadAccountCreationConsent, client);

        case 2:
          consent = _context3.sent;
          _context3.next = 5;
          return (0, _effects.put)((0, _reduxForm.initialize)(ACCOUNT_FORM, (0, _extends3.default)({}, consent, hiddenFields, {
            // NOTE: US-only overrides
            searchable: true,
            searchableDefault: true,
            searchableDisclaimer: '',
            terms: consent.accountDisclaimer
          })));

        case 5:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function doSubmitAccountForm(client, _ref5) {
  var form = _ref5.payload;
  var accountDetails, product, userId;
  return _regenerator2.default.wrap(function doSubmitAccountForm$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(buildAccountDetails, client, form);

        case 3:
          accountDetails = _context4.sent;
          _context4.next = 6;
          return (0, _effects.call)(buildProduct, form);

        case 6:
          product = _context4.sent;
          _context4.next = 9;
          return (0, _effects.call)(createAccount, client, accountDetails, product);

        case 9:
          userId = _context4.sent;
          _context4.next = 12;
          return (0, _effects.call)(_Signup.postSignupTracking, 'email', accountDetails.user, userId);

        case 12:
          _context4.next = 14;
          return (0, _effects.call)(_multitrack.ga, 'Membership Purchase', 'Membership Purchase Account Creation');

        case 14:
          _context4.next = 16;
          return (0, _effects.put)(accountFormAction.success());

        case 16:
          _context4.next = 26;
          break;

        case 18:
          _context4.prev = 18;
          _context4.t0 = _context4['catch'](0);
          _context4.next = 22;
          return (0, _effects.call)(_multitrack.ga, 'Membership Purchase', 'Membership Purchase Account Creation Error', 'Unknown Error');

        case 22:
          _context4.next = 24;
          return (0, _effects.spawn)(logger.error, (0, _deep.deepExtract)('message', _context4.t0, _context4.t0));

        case 24:
          _context4.next = 26;
          return (0, _effects.put)(accountFormAction.failure(new _reduxForm.SubmissionError({ _error: _ApiError.GENERIC_ERROR })));

        case 26:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[0, 18]]);
}

function watchAccountFormSagas(client) {
  return _regenerator2.default.wrap(function watchAccountFormSagas$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, initializeAccountForm().type, doInitializeAccountForm, client);

        case 2:
          _context5.next = 4;
          return (0, _effects.fork)(_effects.takeEvery, accountFormAction.REQUEST, doSubmitAccountForm, client);

        case 4:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}